export const store = {
    getSelectedProducts,
    setSelectedProduct,
    deleteSelectedProducts,
    calculateCheckoutTotal,
    deleteSelectedProduct,
    getCartQty
};

function getSelectedProducts() {
    try{
        const str = sessionStorage.getItem('selectedProducts');
        var products = JSON.parse(str);
        if(products){
            return products
        } else {
            return []
        }
    }
    catch{
        return [];
    }
}

function setSelectedProduct(products) {
    sessionStorage.setItem('selectedProducts', JSON.stringify(products));
}

function deleteSelectedProduct(product) {
    sessionStorage.removeItem('selectedProducts', JSON.stringify(product));
}

function deleteSelectedProducts() {
    var existingProducts =  getSelectedProducts();
     sessionStorage.removeItem('selectedProducts', JSON.stringify(existingProducts));
 }
function calculateCheckoutTotal()
{
    var existingProducts = [];
    existingProducts =  this.getSelectedProducts();
    var orderObject = { subTotal: 0.0, tax: 0.0, shipping: 8.25, totalCost: 0.0 }


    var subTotal = 0;
    var tax = 0;
    tax += Number(orderObject.shipping * 0.0825).toFixed(2);

    for(var i=0;i<existingProducts.length;i++)
    {                  
        if (existingProducts[i].Discount) {
            subTotal = Number(Number(existingProducts[i].Discount * existingProducts[i].Quantity) + subTotal);
            tax = Number(Number(Number(Number(existingProducts[i].Discount * existingProducts[i].Quantity) * 0.0825).toFixed(2)) + Number(tax));
        } else {
            subTotal = Number(Number(existingProducts[i].Cost * existingProducts[i].Quantity) + subTotal);
            tax = Number(Number(Number(Number(existingProducts[i].Cost * existingProducts[i].Quantity) * 0.0825).toFixed(2)) + Number(tax));
        }
    }
    orderObject.subTotal = subTotal.toFixed(2);
    orderObject.tax = tax.toFixed(2);
    orderObject.totalCost = Number(subTotal + tax + orderObject.shipping).toFixed(2);
    //console.log(orderObject,"orderObject");
    return orderObject;
}

function getCartQty() {
    var existingProducts = this.getSelectedProducts();
    var count = 0;
    for (var i = 0; i < existingProducts.length; i++) {
        count += existingProducts[i].Quantity;
    }
    return count;
}
